import {Typography} from "@mui/material"
import {styled} from "@mui/material/styles"

export const Container = styled("div")`
    position: fixed;
    bottom: 0.625rem;
    right: 0.625rem;
    width: 16.5rem;
    padding: 1rem;
    padding-top: 0.625rem;
    border-radius: 4px;
    background-color: ${({theme}) => theme.uxfabric.background.paper};
    border: 1px solid #000000;
`

export const StyledTitle = styled(Typography)`
    padding-bottom: 0rem;
    margin: 0rem;
`

export const Header = styled("div")`
    display: flex;
    padding-bottom: 0.625rem;
`

export const UnstyledButton = styled("button")`
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    color: ${({theme}) => theme.uxfabric.text.primary};
    text-decoration: underline;
    margin-left: auto;
`

export const BodyText = styled(Typography)`
    margin: 0rem;
`
